import { delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";

import { FlowerOnionTrailView } from "./FlowerOnionTrailView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";


export class FlowerOnionTrailController {
    protected view: FlowerOnionTrailView;
    constructor(view: FlowerOnionTrailView) {
        this.view = view;
        this.subscribeEvents();
    }
    /**
     * to subscribe feature events
     */
    private subscribeEvents(): void {
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.SHOW_FLOWER_TRAIL, this.showFlowerTrail, this);
    }
    /**
     * to unsubscribe feature events
     */
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.SHOW_FLOWER_TRAIL, this.showFlowerTrail, this);
    }
    /**
     * to show flower collection trail on onion
     */
    private showFlowerTrail(): void {
        let delayTime: number = 0;
        (ingenuity.parserModel as GameParserModel).getOnionOffset().forEach((offset: number[], index: number) => {
            if (!ingenuity.configData.checkForActualWild[offset[0]]) {
                delayTime = 1500;
                dispatcher.fireEvent(eventDispatchers.PLAY_ONION_EFFECT, { reelId: offset[0], symPos: offset[1] });
                delayedCall("trailWithDelay" + offset[0] + offset[1], 1000, () => {
                    killDelayedCall("trailWithDelay" + offset[0] + offset[1]);
                    this.playTrailAnimation(offset[0], offset[1], index)
                }, this);
            }
        })
        delayedCall("showNextFeatureAfterTrail", delayTime, () => {
            killDelayedCall("showNextFeatureAfterTrail");
            dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
        }, this);
    }
    /**
     * to play flower collection trails
     */
    private playTrailAnimation(reel: number, pos: number, index: number): void {
        const container = this.view.getContainerByID("flowerTrailContainer_" + reel);
        const spine = this.view.cloneSpine();
        container.addChild(spine);
        const trailName = "1x" + (pos + 1);
        this.view.allignTrailSpine(spine, reel, pos)
        spine.playAnim(trailName, false);
        spine.onComplete.addOnce(() => {
            this.resetTrailAnim(reel);
        }, this);
    }
    /**
    * to reset trail after ending
    */
    private resetTrailAnim(reelID: number): void {
        const container = this.view.getContainerByID("flowerTrailMainContainer").children[reelID];
        container && (container.children = []);
        container && (container.removeAll());
    }
}